var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initProductCards = /* @__PURE__ */ __name(($el, productHandle) => {
  var _a;
  const product = utils.JSONParse((_a = document.querySelector(`[data-product-data="${productHandle}"]`)) == null ? void 0 : _a.innerHTML);
  const state = window.Alpine.reactive({
    product
  });
  const renderProductCards = /* @__PURE__ */ __name(async (element, primary_source, secondary_source, hide_if_empty, product_class, desktop_display_limit, mobile_display_limit) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
    const limit = Math.max(desktop_display_limit, mobile_display_limit);
    const fallback_products = utils.JSONParse(
      element.getAttribute("data-fallback-products")
    );
    const products = [];
    switch (primary_source) {
      case "complementary": {
        (_b = (_a2 = state.product) == null ? void 0 : _a2.complementary_products) == null ? void 0 : _b.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        (_d = (_c = state.product) == null ? void 0 : _c.related_products) == null ? void 0 : _d.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          (_f = (_e = window == null ? void 0 : window._recent_products) != null ? _e : []) == null ? void 0 : _f.map(
            ([handle, product_id]) => _product.getHydratedProductData(handle, product_id)
          )
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    switch (secondary_source) {
      case "complementary": {
        (_h = (_g = state.product) == null ? void 0 : _g.complementary_products) == null ? void 0 : _h.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        (_j = (_i = state.product) == null ? void 0 : _i.related_products) == null ? void 0 : _j.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          ((_k = window == null ? void 0 : window._recent_products) != null ? _k : []).map(
            ([handle, product_id]) => _product.getHydratedProductData(handle, product_id)
          )
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    const controlProducts = (_m = (_l = products == null ? void 0 : products.filter((prod) => prod && prod.id !== state.product.id)) == null ? void 0 : _l.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i)) != null ? _m : [];
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        (_n = $el.closest(`.shopify-section`)) == null ? void 0 : _n.classList.toggle("!hidden", (controlProducts == null ? void 0 : controlProducts.length) === 0);
        break;
      case "container":
        (_o = $el.closest(`[data-style-id]:not([data-style-id="${$el.getAttribute("data-style-id")}"])`)) == null ? void 0 : _o.classList.toggle("!hidden", (controlProducts == null ? void 0 : controlProducts.length) === 0);
        break;
      case "block":
        $el == null ? void 0 : $el.classList.toggle("!hidden", (controlProducts == null ? void 0 : controlProducts.length) === 0);
        break;
    }
    const renderProducts = controlProducts == null ? void 0 : controlProducts.filter(
      (prod, index) => {
        var _a3, _b2;
        return prod.handle !== ((_b2 = (_a3 = element.children) == null ? void 0 : _a3[index]) == null ? void 0 : _b2.getAttribute("data-product-handle"));
      }
    );
    if (!renderProducts.length) {
      return;
    }
    element.innerHTML = "";
    controlProducts.slice(0, limit).forEach((prod, i, arr) => {
      var _a3;
      const node = (_a3 = document.querySelector(`[data-product-card='${product_class}']`)) == null ? void 0 : _a3.cloneNode(true);
      if (node) {
        const div = document.createElement("div");
        div.setAttribute("data-product-handle", prod.handle);
        div.setAttribute(
          "class",
          `shrink-0 max-w-full w-full ${i > desktop_display_limit ? "mobile-only" : i > mobile_display_limit ? "desktop-tablet-only" : ""}`
        );
        node == null ? void 0 : node.removeAttribute(`data-product-card`);
        node == null ? void 0 : node.setAttribute("data-product-handle", prod.handle);
        node == null ? void 0 : node.setAttribute("data-product-id", `${prod.id}`);
        node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
          el.remove();
        });
        div.appendChild(node);
        element.appendChild(div);
      }
    });
  }, "renderProductCards");
  _product.getHydratedProductData(product == null ? void 0 : product.handle, product == null ? void 0 : product.id).then((res) => {
    var _a2;
    state.product = ((_a2 = state.product) == null ? void 0 : _a2.handle) === (res == null ? void 0 : res.handle) ? res : state.product;
  });
  return {
    product_cards: {
      state,
      renderProductCards
    }
  };
}, "initProductCards");
window._sections["initProductCards"] = initProductCards;
